import { NewsCardProps } from '../types'
import { AppTitle } from '@otomoro/components/shared/AppTitle'
import { AppText } from '@otomoro/components/shared/AppText'
import { SanityImage } from '@otomoro/components/shared/SanityImage'
import { formatDate } from '@otomoro/helpers/formatDate'
import { resolveHref } from '@otomoro/sanity/lib/sanity.links'
import { Button } from '@otomoro/components/shared/Button'
import { styles } from './NewsCard.css'
import { Arrow } from '@otomoro/components/icons/Arrow'
import { AppLink } from '@otomoro/components/shared/AppLink'

export function NewsCard({
	publishedAt,
	description,
	image,
	thumbnail,
	title,
	duration,
	slug,
	link,
	_type
}: NewsCardProps) {
	const { base, imageClass, figureClass, contentWrapper, titleLink, desc, informationsContainer } = styles()

	return (
		<article className={base()}>
			<SanityImage
				alt={''}
				image={thumbnail || image}
				sizes='(max-width: 768px) 80vw, (max-width: 1200px) 50vw, 60vw'
				className={imageClass()}
				figureClass={figureClass()}
			/>
			<div className={contentWrapper()}>
				<AppLink
					className={titleLink()}
					href={link?.url || resolveHref(_type, slug)}
					target={link?.url ? '_blank' : '_self'}
					rel={link?.url ? 'noopener noreferrer' : undefined}
				>
					<AppTitle variant="h3" as="h3" textTransform="uppercase" className='max-md:!text-h2-mobile'>
						{title}
					</AppTitle>
				</AppLink>
				<AppText size="base" weight='medium' className={desc()} as="p">
					{description}
				</AppText>
				<div className={informationsContainer()}>
					<AppText size="base" weight='medium' className='inline-flex items-center space-x-1'>
						<time dateTime={publishedAt}>{formatDate(publishedAt)}</time><span className="inline-block text-[11px]">&#x2022;</span><span>{duration}</span>
					</AppText>
					<Button as="button" tabIndex={-1} size='singleSmall' single>
						<Arrow orientation="top-right" color="#131313" />
					</Button>
				</div>
			</div>
		</article>
	)
}
